import styled from 'styled-components';
import {device} from 'styled/device';
import {smallClockIcon, smallGuestIcon} from '../../../components/acommon/StyledIcon';

export const Container = styled.div`
  display: flex;
  border: 1px solid #e6e8ec;
  border-radius: 25px;
  min-height: 300px;
  max-width: 540px;
  height: 300px;
  width: 540px;

  &:hover {
    box-shadow: 0 3px 4px #00020334;
    transition: 0.1s;
  }

  @media (max-width: ${device.laptopM}) {
    max-width: none;
    width: 100%;
  }

  @media (max-width: ${device.tablet}) {
    width: 100%;
    height: 100%;
    max-height: fit-content;
  }
`;

export const Col = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Row = styled.div`
  display: flex;
  /* flex-direction: column; */

  .hours {
    display: flex;
    align-items: center;
    font-weight: 400;

    :before {
      content: url(${smallClockIcon});
      position: relative;
      line-height: 1;
      margin-right: 5px;
    }
  }

  .people {
    display: flex;
    align-items: center;
    font-weight: 400;
    margin-left: 15px;

    :before {
      content: url(${smallGuestIcon});
      position: relative;
      line-height: 1;
      margin-right: 5px;
    }
  }

  .desription {
    margin: 15px 0 5px;
    font-weight: 400;
    color: #777e91;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    border-radius: 25px;
    width: 100%;
  }

  @media (max-width: ${device.mobileM}) {
    .hours,
    .people {
      font-size: 14px;
    }

    .desription {
      font-size: 16px;
    }
  }
`;

export const CardRow = styled(Row)`
  width: 100%;
  display: flex;

  .productProperties {
    padding: 30px;
    justify-content: flex-start;
    width: 100%;
  }

  .hoursandpeopleRow {
    padding: 10px 0 10px 0;
    border-bottom: 1px solid #e6e8ec;
    color: #777e91;
    font-size: 12px;
  }

  @media (max-width: ${device.tablet}) {
    display: flex;
    flex-direction: column;

    .productProperties {
      padding: 20px;
    }

    .hoursandpeopleRow {
      padding: 15px 0;
      border-bottom: 1px solid #e6e8ec;
    }
  }
`;

export const RowSpace = styled(Row)`
  justify-content: space-between;
  align-items: center;

  .price {
    color: #23262f;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Poppins', sans-serif;
  }

  .spots {
    color: #fcfcfd;
    font-size: 12px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    background-color: #f84b7a;
    border-radius: 4px;
    padding: 5px 11px;
  }
`;

export const Image = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 25px 0 0 25px;
  max-width: 250px;
  max-height: 300px;
  width: 250px;
  height: 300px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow-x: hidden;

  @media (max-width: ${device.tablet}) {
    border-radius: 25px 25px 0 0;
    max-width: none;
    max-height: 265px;
    width: 100%;
  }
`;

export const PriceLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #32d7be;
  border-radius: 3px;
  width: 50px;
  height: 50px;
  min-width: 50px;

  .oldprice {
    color: #b1b5c4;
    font-weight: 500;
    font-size: 13px;
    text-decoration: line-through;
  }
  .newprice {
    color: #32d7be;
    font-weight: 600;
    font-size: 14px;
  }

  @media (max-width: ${device.tablet}) {
    width: 60px;
    height: 55px;
    min-width: 60px;

    .oldprice {
      font-size: 16px;
      margin-bottom: -2px;
    }
    .newprice {
      font-size: 17px;
      margin-top: -2px;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  color: #23262f;
  font-size: 18px;
  font-weight: 600;
  margin-right: 0.5rem;

  @media (max-width: ${device.tablet}) {
    font-size: 20px;
    font-weight: 500;
  }
`;
